import gql from "graphql-tag";

export const CUSTOMER_APPLICATION_FIELDS = gql`
  fragment CustomerApplicationFields on CustomerApplication {
    id
    companyName
    companyFullName
    companyAccountingName
    companyEmail
    companyPhone
    companyId
    legalAddress
    youcontrolSynced
    sentToOneC
    verificationErrors {
      code
      message
    }
    creationErrors {
      code
      message
    }
    verifiedAt
    companyCode
    companyType
    taxNumber
    comment
    status
    manager {
      id
      storage {
        id
      }
      accessGroup {
        id
      }
    }
    processingManager {
      id
    }
    region {
      id
    }
    user {
      id
      firstName
      lastName
      phone
      email
      customer {
        id
        name
        storage {
          id
        }
        accessGroup {
          id
        }
        companies {
          id
          name
        }
      }
      roles {
        id
        name
      }
    }
    mainActivityDirection
    mainClients
    employeesTotal
    employeesInstallers
    employeesEngineers
    employeesCommercial
    companyYears
    dealerBrands
    trainingMountingService
    trainingCalculationsDesign
    trainingSalesPromotion
    plannedAtmosferaVolumeUsd
    employeesRenewableEnergy
    heardAboutSource
    heardAboutSourceOther
  }
`;
